// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorsCard-cls1_fys","cls2":"AuthorsCard-cls2_XOZ AuthorsCard-cls1_fys"};